/**
 * @method getSuffix
 * @param {Number} length - the length of your item
 * @returns {String} - the suffix
 */
const getSuffix = (length) => {
  if (length === 0) {
    return 's';
  }

  return length > 1 ? 's' : '';
};

export default getSuffix;
